














import { InformationEntryDto } from "@saysimple-platform/dtos";
import { defineComponent, PropType } from "@vue/composition-api";
import { BAlert } from "bootstrap-vue";

export default defineComponent({
    components: {
        BAlert,
    },
    props: {
        entry: {
            type: Object as PropType<InformationEntryDto>,
            required: true,
        },
    },
});
